import * as ramda from 'ramda';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

// @ts-expect-error
import {ActionTypes, CreatorAction} from './creator-actions';
import type {FlashMessage} from './types';

export type CreatorState = {
    flashMessages: {
        [messageId: string]: FlashMessage;
    };
};

const defaultCreatorState = {
    flashMessages: {},
} as const;

export const reducer = (
    state: CreatorState | null | undefined = defaultCreatorState,
    action: CreatorAction
): CreatorState => {
    switch (action.type) {
        case ActionTypes.GLOBAL_CREATE_NEW_FLASH_BANNER_PUSHED: {
            return {
                ...state,
                flashMessages: {
                    // @ts-expect-error
                    ...state.flashMessages,
                    [action.payload.id]: action.payload.flashMessage,
                },
            };
        }
        case ActionTypes.GLOBAL_CREATE_NEW_FLASH_BANNER_REMOVED: {
            return {
                ...state,
                // @ts-expect-error
                flashMessages: ramda.omit([action.payload], state.flashMessages),
            };
        }
        // Prevent any rehydration
        // @ts-expect-error
        case 'persist/REHYDRATE': {
            // @ts-expect-error
            return state;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
